/**
Names of the generated API clients in this build.

Must stay in step with `tools/api-registry.ts` and the directories under
`src/api/generated/`. `api-contract.spec.ts` asserts all three agree, so a
new API cannot ship half-wired.

Used to validate the Shell-supplied `api-base-urls` attribute.
*/
export const API_NAMES: readonly string[] = ['masterdata', 'inventory', 'aggregation'];
